import React from "react";
import { createGlobalStyle } from "styled-components";

const GlobalStyle = createGlobalStyle`

html {
  body{
    opacity: 0;
  }
}

html.wf-active{
  body{
    opacity: 1;
  }
}

.gatsby-image-wrapper {
  width: 100%;
  height: 100%;
}



.tl-edges,
.tl-wrapper {
  box-shadow: none !important;
  overflow: unset;
}

*:focus{
  outline: none !important;
}

body {
  font-family: "soehne-web-kraftig", "Helvetica Neue", "Lucida Grande", sans-serif;
  font-weight: normal;
  font-style: normal;

  /* font-size: 24px; */
  /* line-height: 30px; */

  /* @media(max-width: 1440px){ */
    /* font-size: 21px; */
    /* line-height: 25px; */
  /* } */

  /* @media(max-width: 1000px){ */
    font-size: 18px;
    line-height: 22px;
  /* } */

  text-shadow: 1px 1px 1px rgba(0, 0, 0, .004);
  text-rendering: optimizeLegibility !important;
  -webkit-font-smoothing: antialiased !important;
  -webkit-tap-highlight-color: transparent;

  color: #000;
  margin: 0;

  word-break: break-word;


  cursor: url(/icons/cursor@1x.png) 0 0, pointer;
  cursor: -webkit-image-set(
        url(/icons/cursor@1x.png) 1x,
        url(/icons/cursor@2x.png) 2x
      )
      0 0,
    pointer;
}

input {
  border-radius: 0;
}

h1,h2,h3,h4,h5{
  font-family: "soehne-web-kraftig", "Helvetica Neue", "Lucida Grande", sans-serif;
  font-weight: normal;

  margin: 0;
}


/* Title 1 */
h1{
  /* font-size: 24px; */
  /* line-height: 30px; */

  /* @media(max-width: 1440px){ */
    /* font-size: 21px; */
    /* line-height: 25px; */
  /* } */

  /* @media(max-width: 1000px){ */
    font-size: 18px;
    line-height: 22px;
  /* } */
}

strong {
  font-family: "soehne-web-kraftig", "Helvetica Neue", "Lucida Grande", sans-serif;
  font-weight: normal;
}

.light{
  font-family: "soehne-web-leicht", "Helvetica Neue", "Lucida Grande", sans-serif;
}

em {
  font-style: normal;
}


/*--------------------------------------------------------------
  ## Media
  --------------------------------------------------------------*/

video,
img {
  width: 100%;
  margin: 0;

  display: block;
}

/*--------------------------------------------------------------
  ## Buttons
  --------------------------------------------------------------*/

button{
  background-color: transparent;
  border: 0;
  padding: 0;

  &:focus,
  &:hover{
    outline: none;
  }
}

/*--------------------------------------------------------------
  ## Links
  --------------------------------------------------------------*/
a {
  color: inherit;
  text-decoration: none;

  position: relative;
}

a:visited {
  color: inherit;
}

a:hover,
a:focus,
a:active {
  color: inherit;
}

a:hover,
a:active,
a:focus {
  outline: 0;
}

/*--------------------------------------------------------------
  ## Text
  --------------------------------------------------------------*/

p {
  margin: 0.65em 0;
}

ol, ul, li{
  list-style: none;
  padding: 0;
  margin: 0;
}

/*--------------------------------------------------------------
  ## Box Sizing / Layout
  --------------------------------------------------------------*/

div {
  box-sizing: border-box;
}

`;

export default GlobalStyle;
